import { useSyncExternalStore } from 'react';
import { getPlanState, reloadPlan, subscribePlan } from './planStore';
import type { PlanState } from './planStore';

export type { PlanState };

/**
 * The tab's one plan. A reader — the loading and re-reading live in
 * [planStore], so every surface sees the same arcs at the same moment.
 */
export function usePlan(): { plan: PlanState; reloadPlan: () => void } {
  // The third argument is the same snapshot: the store is a module-level value
  // with no per-request state, so there is nothing for a static render to read
  // differently. Without it, rendering to markup throws rather than reading the
  // plan — which is how the board's own tests fail the moment a leaf component
  // subscribes.
  const plan = useSyncExternalStore(subscribePlan, getPlanState, getPlanState);
  return { plan, reloadPlan };
}
